<template>
    <div class="payroll-info-paid-deals">
        <div class="payroll-info-paid-deals-table" v-loading="loading">
            <div class="table-row table-row-header">
                <template v-for="(column, index) in expenseDealColumns">
                    <div :key="'header_' + index" class="table-cell">
                        {{ column.headerName }}
                    </div>
                </template>
            </div>
            <template v-for="(expense, expenseIndex) in expenses">
                <div class="table-row" :key="expense.data.deal_id">
                    <template v-for="(column, columnIndex) in expenseDealColumns">
                        <div
                            :key="expenseIndex+ '_'+ columnIndex"
                            :class="[column.fieldClass, 'table-cell']"
                        >
                            <template v-if="column.field === 'deal_id'">
                                <a :href="getDealLink(expense.data[column.field])" target="_blank" class="link">
                                    {{ expense.data[column.field] }}
                                </a>
                            </template>
                            <template v-else-if="column.field === 'amount'">
                                <span :class="{'red': expense.data.amount < 0}">
                                    {{ formatFinance(expense.data[column.field]) }}
                                </span>
                            </template>
                            <template v-else>
                                {{ expense.data[column.field] }}
                            </template>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { formatFinance } from '@/common/utilities';

export default {
    name: 'PayrollInfoEmployerPaidDealsGrid',
    props: {
        expenses: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            expenseDealColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: '' },
                { headerName: 'Договор', field: 'contract', fieldClass: '' },
                { headerName: 'Адрес', field: 'address', fieldClass: '' },
                { headerName: '1% за заключение', field: 'bonus_1_percent', fieldClass: 'text-right pr10' },
                { headerName: 'Бонус сверх 50/50', field: 'bonus_measurer', fieldClass: 'text-right pr10' }, //только для замерщика
                { headerName: 'Бонус', field: 'bonus_deal', fieldClass: 'text-right pr10' },
                { headerName: 'Штраф', field: 'fine_deal', fieldClass: 'text-right pr10' },
                { headerName: 'Жалюзи руб', field: 'jalousie', fieldClass: 'text-right pr10' },
                { headerName: 'Отделка руб', field: 'finish', fieldClass: 'text-right pr10' },
                { headerName: 'Рекламация материалы', field: 'complaint_materials', fieldClass: 'text-right pr10' },
                { headerName: 'Рекламация работа', field: 'complaint_work', fieldClass: 'text-right pr10' },
                //{ headerName: 'Бонус менеджеру', field: 'bonus_manager', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Выдано', field: 'paid', fieldClass: 'text-right pr10' }
            ],
            loading: false
        };
    },
    computed: {
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        }
    }
};
</script>
